import faker from 'faker/locale/id_ID'

const range = len => {
  const arr = []
  for (let i = 0; i < len; i++) {
    arr.push(i)
  }
  return arr
}

const dataTypeSample = [
  'Online Book',
  'Files',
  'Video',
  'Audio',
]

const dataCategorySample = [
  'Modul',
  'Buku',
  'Laporan',
  'Penelitian',
]

const dataVisibilitySample = [
  'Public',
  'Official Member',
  'All Member'
]

const dataSubmissionSample = [
  'draft',
  'under_review',
  'approved',
]

const data = () => {
  return {
    id: faker.random.number(),
    title: faker.lorem.words(3),
    type: faker.random.arrayElement(dataTypeSample),
    category: faker.random.arrayElement(dataCategorySample),
    visibility: faker.random.arrayElement(dataVisibilitySample),
    submission: faker.random.arrayElement(dataSubmissionSample),
  }
}

function makeData(limit) {
  return range(limit).map(d => {
    return {
      ...data()
    }
  })
}

export default makeData
